import { useEffect, useState } from "react";
import { chunk, shuffle as randomize } from "lodash";
import Modal from "./common/Modal";
import "./Memory.scss";
import { TIME, resolveTime } from "./common/utils";

let IMAGE_MAP = [
    ["/img/emotions/single-strawberry.png", "/img/emotions/table-lamp.png"],
    ["/img/emotions/transparent-clouds.png", "/img/emotions/table-lamp.png"],
    [
      "/img/emotions/single-strawberry.png",
      "/img/emotions/transparent-clouds.png"
    ]
  ],
  ROWS = IMAGE_MAP.length,
  COLUMNS = IMAGE_MAP[0].length;
IMAGE_MAP = IMAGE_MAP.flat();

const Memory = ({ feature, onDone, start = null, end = null }) => {
  const [state, setState] = useState(
      Array.from({ length: ROWS * COLUMNS }).fill(0)
    ),
    [modal, setModal] = useState(true),
    [modalType, setModalType] = useState("START"),
    [moves, setMoves] = useState(0),
    [seconds, setSeconds] = useState(0),
    [playAgain, setPlayAgain] = useState(false),
    shuffle = () => {
      setPlayAgain(true);
      IMAGE_MAP = randomize(IMAGE_MAP);
      setMoves(0);
      setSeconds(0);
      setState(Array.from({ length: ROWS * COLUMNS }).fill(0));
    },
    showItem = (row, column) => {
      let array = [...state],
        reset = array
          .map((item, index) => ({ index, value: item }))
          .filter(item => item.value === 1),
        newIndex = row * COLUMNS + column,
        statistics = { score: moves };
      if (reset.length === 2) reset.map(item => (array[item.index] = 0));
      if (reset.length === 1) {
        statistics.score += 1;
        setMoves(moves + 1);
        let oldIndex = reset[0].index;
        if (IMAGE_MAP[oldIndex] === IMAGE_MAP[newIndex]) {
          array[oldIndex] = 2;
          array[newIndex] = 2;
        }
      }
      if (array[newIndex] === 0) array[newIndex] = 1;
      setState(array);
      if (
        array.reduce((prev, current) => prev + current, 0) ===
        ROWS * COLUMNS * 2
      ) {
        if (end) end(statistics);
        setModalType("END");
        setModal(true);
      }
    };
  useEffect(() => {
    IMAGE_MAP = randomize(IMAGE_MAP);
    setModal(true);
    setModalType("START");
    setState(Array.from({ length: ROWS * COLUMNS }).fill(0));
    setMoves(0);
    setSeconds(0);
    setPlayAgain(false);
  }, []);
  useEffect(() => {
    if (modalType === "") {
      let cancel = false;
      let timeout = TIME(seconds, setSeconds, cancel);
      return () => {
        clearTimeout(timeout);
        cancel = true;
      };
    }
  }, [modalType, seconds]);
  return (
    <>
      <Modal
        feature={feature}
        show={modal}
        type={modalType}
        kind={"MEMORY"}
        intro={`The game consists of remembering the location of the objects in
                the card.`}
        stats={{ moves, time: resolveTime(seconds) }}
        done={() => {
          if (modalType === "START") {
            if (start) start(playAgain ? "PLAY_AGAIN" : "START");
            setModal(false);
            setModalType("");
          } else if (modalType === "END") {
            setModal(false);
            setModalType("");
            onDone();
          }
        }}
        reset={() => {
          setModal(true);
          setModalType("START");
          shuffle();
        }}
      />
      <div className="game-memory">
        <div className="game-memory-title">Memory Game</div>
        <div className="game-memory-stats">
          <div>{`${moves} moves`}</div>
          <div>{resolveTime(seconds)}</div>
          <div className="game-memory-shuffle" onClick={() => shuffle()}>
            <i className="fa fa-redo" style={{ color: "#002BFF" }}></i>
          </div>
        </div>
        <div className="game-memory-matrix">
          {chunk(IMAGE_MAP, COLUMNS).map((row, rowIndex) => (
            <div key={`item${rowIndex}`} className="game-memory-matrix-row">
              {row.map((column, columnIndex) => {
                let index = rowIndex * COLUMNS + columnIndex;
                return (
                  <div
                    key={`item${rowIndex}${columnIndex}`}
                    className="game-memory-matrix-column"
                  >
                    {state[index] === 0 ? (
                      <div
                        onClick={() => showItem(rowIndex, columnIndex)}
                        className="game-memory-matrix-item game-memory-matrix-column-hidden"
                      />
                    ) : (
                      <div
                        className={`game-memory-matrix-item game-memory-matrix-column-${
                          state[index] === 2 ? "done" : "show"
                        }`}
                      >
                        <img src={column} alt="Item" />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Memory;
